import { useAppSelector } from '~/store'

/**
 * @description Get the current language of the app from redux store
 * @returns - Current language of the app
 */
export default function useLanguage() {
    return useAppSelector((state) => state.initial.language)
}
